import { V2Device, V2DevicePersonalisation } from 'ctp-search-device';
import { Personalisation } from 'ctp-personalisation-search';
import { PersonalisationState, INavigation } from './types';

/**
 * Retrieves a list of instances for a device
 * Long IDs are stored in perso state.instances
 * For VDO Links, DTCO is linked to instances (not device ID)
 * @param device a full device object to make decisions on device type
 */
const getters = {
  getNavigationConfiguration(state: PersonalisationState): INavigation {
    return state.navigation;
  },
  getInstanceNamesByDeviceID: (state: PersonalisationState) => (model: { device: V2Device, perso: V2DevicePersonalisation }) => {
    const instanceNames = state.instanceNames.filter((d) => {
      if (model.perso.persoTargetType === V2DevicePersonalisation.PersoTargetTypeEnum.Dtco) {
        return d.id === model.perso.persoTargetID;
      }
      return d.id === model.device.id || d.id.slice(4) === model.device.id;
    });
    return instanceNames.length > 0 ? instanceNames[0].instances : [];
  },
  getDeviceCount(state: PersonalisationState) {
    return state.deviceCount;
  },
  getPersonalisationState(state: PersonalisationState) {
    return state.personalisationState;
  },
  getPersonalisations(state: PersonalisationState): Personalisation[] {
    return state.personalisations;
  },
  getTotalPersonalisations(state: PersonalisationState): number {
    return state.totalSize;
  },
  getPersonalisationDetails(state: PersonalisationState) {
    return state.personalisationDetails;
  }
};
export default getters;
